/**
 * Shared case vocabulary for the admin UI — status labels/colours, pipeline order,
 * category icons, formatters. Keeps the pipeline board, table and detail consistent.
 */
import { Home, ShoppingBasket, HeartPulse, HandHelping } from 'lucide-react';

export const PIPELINE = [
  'intake',
  'field_verify',
  'pending_approval',
  'approved',
  'disbursed',
  'delivered',
  'closed',
];

export const STATUS_META = {
  intake: { label: 'Intake', tone: 'slate' },
  field_verify: { label: 'Field verify', tone: 'blue' },
  pending_approval: { label: 'Pending approval', tone: 'gold' },
  approved: { label: 'Approved', tone: 'green' },
  disbursed: { label: 'Disbursed', tone: 'teal' },
  delivered: { label: 'Delivered', tone: 'green' },
  closed: { label: 'Closed', tone: 'dark' },
  rejected: { label: 'Rejected', tone: 'red' },
};

export const CATEGORY_META = {
  housing: { label: 'Housing', icon: Home },
  ration: { label: 'Ration', icon: ShoppingBasket },
  medical: { label: 'Medical', icon: HeartPulse },
  other: { label: 'Other', icon: HandHelping },
};

export function formatINR(n) {
  if (n == null) return '—';
  return `₹${Number(n).toLocaleString('en-IN')}`;
}

export function formatDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function relativeTime(d) {
  if (!d) return '';
  const diff = Date.now() - new Date(d).getTime();
  const days = Math.floor(diff / 86400000);
  if (days === 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 30) return `${days}d ago`;
  return formatDate(d);
}
